import { Reveal } from './Reveal';
import {
  LANDING_ANCHORS,
  LANDING_MODULOS,
  LANDING_TAMBEM_INCLUI,
  type ModuloItem,
} from '../../domain/landingContent';

const TRANS = 'transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)]';

function ModuloCard({ icon: Icon, titulo, descricao, destaque }: ModuloItem) {
  return (
    <div
      className={`group ${TRANS} relative h-full overflow-hidden rounded-[2rem] border border-white/[0.06] bg-white/[0.03] p-6 hover:border-orange-500/30 hover:bg-white/[0.05] sm:p-7`}
    >
      {destaque && (
        <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-orange-500/10 blur-3xl" />
      )}
      <div className="relative">
        <span
          className={`${TRANS} inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-500/10 text-orange-400 ring-1 ring-inset ring-white/5 group-hover:scale-110`}
        >
          <Icon className="h-5 w-5" />
        </span>
        <h3 className="mt-5 min-w-0 break-words text-lg font-semibold text-white">{titulo}</h3>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-400">{descricao}</p>
      </div>
    </div>
  );
}

/** Grade bento de módulos — Operação + Engajamento. */
export function LandingModules() {
  return (
    <section
      id={LANDING_ANCHORS.modulos}
      className="mx-auto max-w-6xl scroll-mt-24 px-4 py-24 sm:px-6 sm:py-32"
    >
      <Reveal className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Tudo o que o salão precisa numa só plataforma
        </h2>
        <p className="mt-3 text-sm text-slate-400 sm:text-base">
          Módulos de operação e engajamento integrados — sem sistemas paralelos.
        </p>
      </Reveal>

      <div className="mt-16 space-y-16">
        {LANDING_MODULOS.map((grupo, gi) => (
          <div key={grupo.titulo}>
            <Reveal delay={gi * 0.04}>
              <div className="mb-8">
                <h3 className="text-xl font-bold text-white sm:text-2xl">{grupo.titulo}</h3>
                <p className="mt-1 text-sm text-slate-400">{grupo.subtitulo}</p>
              </div>
            </Reveal>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {grupo.modulos.map((m, i) => (
                <Reveal key={m.titulo} delay={i * 0.05} className="h-full">
                  <ModuloCard {...m} />
                </Reveal>
              ))}
            </div>
          </div>
        ))}
      </div>

      <p className="mt-12 text-center text-sm text-slate-500">{LANDING_TAMBEM_INCLUI}</p>
    </section>
  );
}
